import React, { useMemo, useState, useEffect } from 'react';
import { getQuickRepliesApi } from '../../api/replies';
import { QuickReply } from '../../types';

interface QuickReplyPopupProps {
  onSelect: (message: string) => void;
  search: string;
}

const QuickReplyPopup: React.FC<QuickReplyPopupProps> = ({ onSelect, search }) => {
  const [quickReplies, setQuickReplies] = useState<QuickReply[]>([]);
  
  useEffect(() => {
    const fetchReplies = async () => {
      try {
        const replies = await getQuickRepliesApi();
        setQuickReplies(replies);
      } catch (error) {
        console.error("Failed to fetch quick replies for popup:", error);
      }
    };
    fetchReplies();
  }, []);

  const filteredReplies = useMemo(() => {
    if (!search) return quickReplies;
    return quickReplies.filter(reply =>
      reply.shortcut.toLowerCase().includes(search.toLowerCase())
    );
  }, [search, quickReplies]);

  if (filteredReplies.length === 0) {
    return null;
  }

  return (
    <div className="absolute bottom-full left-3 right-3 mb-2 bg-popover border border-border rounded-lg shadow-lg z-20 max-h-60 overflow-y-auto">
      <ul>
        {filteredReplies.map(reply => (
          <li
            key={reply.id}
            onClick={() => onSelect(reply.content)}
            className="p-3 hover:bg-muted cursor-pointer flex justify-between items-center"
          >
            <div>
              <p className="font-semibold text-foreground">/{reply.shortcut}</p>
              <p className="text-sm text-muted-foreground truncate">{reply.content}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuickReplyPopup;
